import React, {useState, useEffect, useRef} from 'react';
import axios from "axios";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {TabView, TabPanel} from 'primereact/tabview';
import {Toast} from "primereact/toast";
import {InputText} from 'primereact/inputtext';
import '../../css/DataTableDemo.css'
import {Tag} from 'primereact/tag';
import {Message} from "primereact/message";
import {Card} from 'primereact/card';
import {DataView} from "primereact/dataview";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";


const CmsContentList = props => {

    const toast = useRef(null);
    const [contentListPublished, setContentListPublished] = useState([]);
    const [data, setData] = useState([]);
    const [contentListAll, setContentListAll] = useState([]);
    const [contentDraftList, setContentDraftList] = useState([]);
    const [contentTrashList, setContentTrashList] = useState([]);
    const [contentArchiveList, setContentArchiveList] = useState([]);
    const [contentTypeList, setContentTypeList] = useState([]);
    const [contentCategoryList, setContentCategoryList] = useState([]);
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [trashDeleteDialog, setTrashDeleteDialog] = useState(false);
    const [archiveDialog, setArchiveDialog] = useState(false);
    const [introId, setIntroId] = useState(null);
    const [introFavId, setIntroFavId] = useState(null);
    const [contCount, setContCount] = useState(null);
    const [contCountPublis, setContCountPublis] = useState(null);
    const [contCountDraft, setContCountDraft] = useState(null);
    const [contCountTrash, setContCountTrash] = useState(null);
    const [contCountArchive, setContCountArchive] = useState(null);
    const [contCountPasive, setContCountPasive] = useState(null);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const dt = useRef(null);
    const [fileList, setFileList] = useState([]);
    const content_list_role = localStorage.getItem('cms_list') ? true : false;
    const cmsPublish = !!localStorage.getItem('cms_publish');
    const [approvalContID, setApprovalContID] = useState(null);
    const [createTime, setCreateTime] = useState(null);
    const [modulID, setModulID] = useState(null);
    const [contType, setContType] = useState('');
    const [contText, setContText] = useState('');
    const [contSlug, setContSlug] = useState('');
    const [userName, setUserName] = useState('');
    const [contTitle, setContTitle] = useState('');
    const [contentPreviewDialog, setContentPreviewDialog] = useState(false);
    const [allContentPreviewDialog, setAllContentPreviewDialog] = useState(false);
    const contentAddRole = !!localStorage.getItem('cms_add');


    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    let all_table_header_tabpanel = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Tümü ({contCount}) </b></h6>

        </div>);
    let table_header_waiting_for_approval = (

        <div className="p-mt-1">
            <h6 style={{color: 'red'}} className="p-mb-2"><b>Onay Bekleyenler ({contCountPasive})</b></h6>

        </div>);

    let table_header_publish = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Yayında({contCountPublis}) </b></h6>

        </div>);

    let table_header_draft = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Taslak ({contCountDraft}) </b></h6>

        </div>);

    let table_header_trash = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Çöp ({contCountTrash}) </b></h6>

        </div>);

    let table_header_archive = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Arşiv ({contCountArchive}) </b></h6>

        </div>);


    useEffect(() => {
        getContentPublished();
        getContentListDraft();
        getContentListAll();
        getContentListTrash();
        getOnlyTypeList();
        getOnlyCategoryList();
        getContentListArchive();
        getWaitApproval();
        getWaitApprovalPreview();


    }, []);


    const getContentListAll = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content/', {"headers": headers})
            .then(res => {
                setContentListAll(res.data.CmsContent)
                setContCount(res.data.total_content)
                setContCountPublis(res.data.total_content_published)
                setContCountDraft(res.data.total_content_draft)
                setContCountTrash(res.data.count_record_trash)
                setContCountArchive(res.data.count_record_archive)
                const data = res.data
                if (data.result) {
                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }
            })


    }
    const getContentPublished = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content_published/', {"headers": headers})
            .then(res => {
                setContentListPublished(res.data.CmsContentPublished)
                // (contentListPublished, "ascscsac")
            })
    }
    const getWaitApproval = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cms_wait_approval/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            setContCountPasive(res.data.count_record_pasive)
                            setData(data.result)
                        } else {

                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }
    const selectContentPreview = (cont_id) => {
        setContentPreviewDialog(true)
        getWaitApprovalPreview(cont_id)
        getContentFile(cont_id)

    }
    const getWaitApprovalPreview = (cont_id) => {
        // //console.log(contPreviewID, '/*//*//*')
        const token = localStorage.getItem("token");

        const headers = {"Authorization": "Token " + token}
        if (cont_id !== undefined) {
            axios.get('/api/cms_wait_approval_preview' + `/${cont_id}/`, {"headers": headers})


                .then(res => {
                    const data = res.data.cms_content_preview
                    // //console.log(data, "dataaa")
                    for (let i = 0; i < data.length; i++) {
                        const file = data[i];
                        setApprovalContID(file.cont_id)
                        setCreateTime(file.cont_createtime)
                        setModulID(file.md_name)
                        setContType(file.cont_type)
                        setContText(file.cont_text)
                        setUserName(file.user_name)
                        setContTitle(file.cont_title)

                    }

                    //console.log(data[0].cont_text, "saascacacas")
                    //console.log(contText, "saascacacas")
                    //console.log(<p dangerouslySetInnerHTML={{__html: {contText}}}/>

                })

        }
    }
    const contentPreview = (rowdata) => {
        var cont_id = rowdata['cont_id']
        var cont_flag_active = rowdata['cont_flag_active']
        var cont_flag_archive = rowdata['cont_flag_archive']
        var cont_flag_delete = rowdata['cont_flag_delete']
        var cont_flag_draft = rowdata['cont_flag_draft']
        var cont_slug = rowdata['cont_slug']
        if (cont_flag_delete === false && cont_flag_draft === false && cont_flag_archive === false && cont_flag_active === true) {
            var staticurl = "https://ssyz.org.tr/contents/detail/"
            staticurl = staticurl + cont_slug
            window.open(staticurl, "_blank");
        } else {
            setAllContentPreviewDialog(true)
            getContentPreview(cont_id)
            getContentFile(cont_id)

        }


    }
    const getContentPreview = (cont_id) => {
        // //console.log(contPreviewID, '/*//*//*')
        const token = localStorage.getItem("token");

        const headers = {"Authorization": "Token " + token}
        if (cont_id !== undefined) {
            axios.get('/api/cms_content_preview' + `/${cont_id}/`, {"headers": headers})


                .then(res => {
                    const data = res.data.cms_content_preview
                    console.log(data, "dataaa")
                    for (let i = 0; i < data.length; i++) {
                        const file = data[i];
                        setApprovalContID(file.cont_id)
                        setContSlug(file.cont_slug)
                        setCreateTime(file.cont_createtime)
                        setModulID(file.md_name)
                        setContType(file.cont_type)
                        setContText(file.cont_text)

                        setUserName(file.user_name)
                        setContTitle(file.cont_title)

                    }

                    //console.log(res.data.cms_content_preview, "geldiii")

                })

        }
    }
    const getContentFile = (cont_id) => {
        // //console.log(cont_id, "contttttttttttttttt")
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content_files' + `/${cont_id}/`, {"headers": headers})
            .then(res => {
                const res_file = res.data.result_file
                //console.log(res.data.result_file, "+++")
                if (res_file !== null && res_file !== undefined) {
                    setFileList(res_file)

                }
            })

    }
    const getContentListDraft = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content_draft/', {"headers": headers})
            .then(res => {
                setContentDraftList(res.data.CmsContentDraft)
            })
    }
    const getContentListArchive = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content_archive/', {"headers": headers})
            .then(res => {
                setContentArchiveList(res.data.CmsContentArchive)
            })
    }
    const getContentListTrash = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content_trash/', {"headers": headers})
            .then(res => {
                setContentTrashList(res.data.CmsContentTrash)
            })
    }
    const getOnlyTypeList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/only/type/list/', {"headers": headers})
            .then(res => {
                setContentTypeList(res.data)
            })
    }
    const getOnlyCategoryList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/only/category/list/', {"headers": headers})
            .then(res => {
                setContentCategoryList(res.data)
            })
    }
    const createNewContent = () => {
        window.location = '#/content'
    }
    const selectContent = (cont_id) => {
        const url = "/content/" + cont_id + "/";
        window.location.hash = url
    }
    const unarchiveContent = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            cont_id: cont_id,

        };

        // ("adasd", cont_id)
        axios.put('/api/cms_content_archive_reverse' + `/${cont_id}/`, obj, {"headers": headers})

            .then(res => {
                const data = res.data;

                if (data.result) {

                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }

                getContentListAll()
                getContentListArchive()
                getContentListDraft()


            });
    }
    const actionTemplateAll = (rowData) => {
        //    // (rowData['cip_id'])
        return <div>
            {contentAddRole ?
                <React.Fragment>


                    <Button icon="pi pi-pencil" className=" p-button-warning p-mr-2" tooltip="Düzenle"
                            onClick={() => selectContent(rowData['cont_id'])}
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>


                    <Button icon="pi pi-trash" className=" p-button-danger "
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            onClick={() => deleteRow(rowData['cont_id'])} tooltip="Çöp"
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>


                </React.Fragment>
                :
                <div></div>}


        </div>
            ;
    }
    const actionTemplateArchive = (rowData) => {
        //    // (rowData['cip_id'])
        return <div>
            {contentAddRole ?  <React.Fragment>

                <Button icon="pi pi-caret-left" className="p-button-rounded p-button-warning p-mb-3"
                        label="Geri Al"
                        onClick={() => unarchiveContent(rowData['cont_id'])}
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-mb-3"
                        onClick={() => deleteRow(rowData['cont_id'])} label="Çöp"
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


            </React.Fragment> : <div></div>}




        </div>
            ;
    }
    const views = (rowData) => {
        return <div>
            {contentAddRole ?
                <div>
                    <Button tooltip="Görüntüle" className="p-button-icon p-mr-2" icon="pi pi-search"
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            style={{maxWidth: '2em'}} onClick={() => contentPreview(rowData)}/>

                    <Button tooltip="Arşivle" className="p-button-secondary p-mr-2" icon="pi pi-eye-slash "
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            onClick={() => archiveRow2(rowData['cont_id'])}/>
                </div>
                :
                <div></div>
            }


        </div>
    }
    const cardItemsAllContent = (item) => {
        //    // (rowData['cip_id'])
        return <div className="p-grid">
            <div className="p-card-title p-md-12">
                <Tag severity="warning" value="Arşiv"
                     style={{display: item.cont_flag_archive === true && item.cont_flag_delete === false ? 'block' : 'none'}}> <
                         /Tag>
                <Tag severity="info" value="Taslak"
                     style={{display: item.cont_flag_draft === true && item.cont_flag_delete === false ? 'block' : 'none'}}>

                </Tag>
                <Tag severity="success" value="Yayında"
                     style={{display: item.cont_flag_draft === false && item.cont_flag_delete === false && item.cont_flag_archive === false && item.cont_flag_active === true ? 'block' : 'none'}}>

                </Tag>
                <Tag severity="danger" value="Onay Bekliyor"
                     style={{display: item.cont_flag_active === false ? 'block' : 'none'}}>

                </Tag>


            </div>
        </div>
    }
    const actionTemplateDraft = (rowData) => {
        return <div>
            {contentAddRole ?
                <div>


                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-warning p-mr-2" tooltip="Düzenle"
                            onClick={() => selectContent(rowData['cont_id'])}
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                    />


                    <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
                            onClick={() => deleteRow(rowData['cont_id'])} tooltip="Çöp"
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                    />


                </div>
                :
                <div></div>
            }


        </div>;
    }
    const actionTemplateTrash = (rowData) => {
        return <div>
            {contentAddRole ?
                <React.Fragment>

                    <Button icon="pi pi-arrow-circle-left" className="p-button-warning p-mr-3"
                            tooltip="Geri Al"
                            onClick={() => backContent(rowData['cont_id'])}
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                    />

                    <Button icon="pi pi-trash" className=" p-button-danger "
                            onClick={() => deleteTrash(rowData['cont_id'])} tooltip="Kalıcı Sil"
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                    />

                </React.Fragment>
                :
                <div></div>
            }


        </div>
            ;
    }
    const actionTemplateApproval = (rowData) => {
        return <div>
            {contentAddRole ? <React.Fragment>
                <Button tooltip="Ön izleme" className="p-button-rounded p-mr-2" icon="pi pi-search"
                        style={{
                            visibility: cmsPublish ? 'visible' : 'hidden'
                        }} onClick={() => selectContentPreview(rowData['cont_id'])}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


                <Button icon="pi pi-pencil" className="p-button-rounded p-button-warning p-mr-2" tooltip="Düzenle"
                        onClick={() => selectContent(rowData['cont_id'])}
                        // style={{display: contentAddRole ? 'block' : 'none'}}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"

                        onClick={() => approvalReject(rowData['cont_id'])} tooltip="Reddet" style={{
                    visibility: cmsPublish ? 'visible' : 'hidden', display: contentAddRole ? 'block' : 'none'
                }}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


            </React.Fragment> : <div></div>
            }


        </div>;
    }
    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}

                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteCont(introId)} autoFocus
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
            </div>
        );
    }
    const renderFooter2 = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setArchiveDialog(false)}
                        className="p-button-text"
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                <Button label="Evet" icon="pi pi-check" onClick={() => archiveRow(introId)} autoFocus
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
            </div>
        );
    }
    const renderFooterTrashDelete = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setTrashDeleteDialog(false)}
                        className="p-button-text"
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteTrashRow(introFavId)} autoFocus
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />
            </div>
        );
    }
    const deleteTrash = (contID) => {


        setTrashDeleteDialog(true)
        setIntroFavId(contID)
    }
    const deleteTrashRow = (cont_id) => {
            const token = localStorage.getItem("token");
            const headers = {"Authorization": "Token " + token}
            axios.delete('/api/cms_content_trash_delete' + `/${cont_id}/`, {"headers": headers})
                .then(res => {
                    const data = res.data
                    if (data.result) {
                        showSuccess(data.message);
                    } else {
                        showError(data.message);
                    }
                    getWaitApproval();
                    getContentListAll();
                    getContentListTrash();
                    setTrashDeleteDialog(false)
                    setIntroId(null)

                });
        }
    ;
    const deleteRow = (contID) => {


        setCipDeleteDialog(true)
        setIntroId(contID)
    }
    const archiveRow2 = (contID) => {


        setArchiveDialog(true)
        setIntroId(contID)
    }
    const deleteCont = (contID) => {
            const token = localStorage.getItem("token");
            const headers = {"Authorization": "Token " + token}
            axios.delete('/api/cms_content' + `/${contID}/`, {"headers": headers})
                .then(res => {
                    const data = res.data
                    if (data.result) {

                        showSuccess(data.message);
                    } else {
                        showError(data.message);
                    }
                    getWaitApproval();
                    getContentListDraft()
                    getContentListAll();
                    getContentListTrash();

                    setCipDeleteDialog(false)
                    setIntroId(null)

                });
        }
    ;
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            detail: message,
            life: 3000
        });
    }
    const approvalReject = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            cont_id: cont_id,

        };


        axios.put('/api/cms_content_approval' + `/${cont_id}/`, obj, {"headers": headers})
            .then(res => {
                const data = res.data;
                getWaitApproval();
                getContentListDraft()
                getContentListAll()
                if (data.result) {
                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }


            });
    }
    const archiveRow = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            cont_id: cont_id,

        };


        axios.put('/api/cms_content_archive' + `/${cont_id}/`, obj, {"headers": headers})
            .then(res => {
                const data = res.data;

                if (data.result) {

                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }
                setArchiveDialog(false)
                getContentListAll()
                getContentListArchive()


            });
    }
    const backContent = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            cont_id: cont_id,

        };

        // ("adasd", cont_id)
        axios.put('/api/cms_content_trash' + `/${cont_id}/`, obj, {"headers": headers})
            .then(res => {
                getContentListTrash();
                getContentListAll()
                getContentListDraft()

                const data = res.data
                if (data.result) {
                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }


            });
    }
    const contentTime = rowData => {
        return <div style={{display: 'inline-flex'}}>
            <b>{(rowData['cont_createtime'])}</b>
            {/*<div style={{display: 'inline-flex'}}>*/}
            {/*    18/08/2021 10:41:41*/}
            {/*</div>*/}
        </div>

    }
    const cardItemsImage = (item) => {

        if (item.cft_id === 2) {
            if (item.file_type === "image") {


                return (


                    <img src={item.cmfl_filepath} className="p-md-12" style={{width: '400px', height: '400px'}}/>


                )

            }
        } else {
            return (
                null
            )
        }


    }


    if (content_list_role) {

        return (

            <div>
                <Toast ref={toast}/>


                <Dialog header="UYARI" visible={cipDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}
                        onHide={() => setCipDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-trash p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>İçerik Çöp Kutusuna Atılsın mı?</span>
                    </div>
                </Dialog>

                <Dialog header="UYARI" visible={archiveDialog}
                        style={{width: '20%'}}
                        footer={renderFooter2()}
                        onHide={() => setArchiveDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-trash p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>İçerik arşivlenecek! Onaylıyor musunuz?</span>
                    </div>
                </Dialog>
                <Dialog header="İçerik Ön izleme" visible={contentPreviewDialog}
                        style={{width: '50vw'}}
                        onHide={() => setContentPreviewDialog(false)}>
                    <Card title={contTitle} subTitle={createTime}>
                        <DataView value={fileList} layout={'grid'}
                                  itemTemplate={cardItemsImage} className="p-mt-3"
                        />
                        <p className="p-mt-3"><b>İçerik Türü:</b> {contType}</p>
                        <p className="p-mt-3 p-mb-3"><b>Modül:</b> {modulID}</p>
                        <h5>Haber Detayı</h5>
                        <p dangerouslySetInnerHTML={{__html: contText}}/>


                    </Card>

                </Dialog>
                <Dialog header="İçerik Ön izleme" visible={allContentPreviewDialog}
                        style={{width: '50vw'}}
                        onHide={() => setAllContentPreviewDialog(false)}>
                    <Card title={contTitle} subTitle={createTime}>
                        <DataView value={fileList} layout={'grid'}
                                  itemTemplate={cardItemsImage} className="p-mt-3"
                        />
                        <p className="p-mt-3"><b>İçerik Türü:</b> {contType}</p>
                        <p className="p-mt-3 p-mb-3"><b>Modül:</b> {modulID}</p>
                        <h5>Haber Detayı</h5>
                        <p dangerouslySetInnerHTML={{__html: contText}}/>


                    </Card>

                </Dialog>

                <Button label="Yeni İçerik  Ekle" icon="pi pi-plus" className="p-button-success p-mb-5"
                        onClick={createNewContent}
                        style={{width: '150px', height: '35px', display: contentAddRole ? 'block' : 'none'}}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                <TabView className="tabview-custom">

                    <TabPanel header={all_table_header_tabpanel} classname="p-mr-2"
                              leftIcon="pi pi-calendar p-mr-2">

                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Tüm İçerikler</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable

                                    ref={dt}
                                    value={contentListAll}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >
                                    <Column

                                        body={cardItemsAllContent}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}

                                    />
                                    <Column

                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '0.5em'}}
                                        header="No"
                                        sortable


                                    />

                                    <Column

                                        body={views}
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />


                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', width: '200px'}}
                                        header="Başlık"


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />
                                    <Column field={'cont_slug'}
                                            header="Url"
                                            style={{textAlign: 'center', display: 'none'}}

                                    />
                                    <Column
                                        field={'md_name'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="Modül"


                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>


                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            header="Oluşturulma"
                                            sortable
                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />
                                    <Column
                                        field={'cont_pfinishtime'}
                                        header="Bitiş"
                                        sortable
                                        style={{textAlign: 'center'}}/>

                                    <Column field={'cont_updatetime'}

                                            header="Güncellenme"
                                            sortable
                                            style={{textAlign: 'center'}}
                                    />


                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        header="İşlevler"
                                        body={actionTemplateAll}
                                        style={{textAlign: 'center'}}
                                    />


                                </DataTable>
                            </div>
                        </div>


                    </TabPanel>

                    <TabPanel header={table_header_waiting_for_approval} classname="p-mr-2"
                              leftIcon="pi pi-replay p-mr-2">


                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Onay Bekleyen İçerikler</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <div className="p-col-12 p-md-12 p-mb-4">
                                    <Message severity="info"
                                             text="Uyarı: Onaylama yetkisi sadece içerik yayımlama yetkisi olan kullanıcılara atanmıştır. Bu yetkiye sahip olmayan
                                             kullanıcılar onay bekleyen içeriği düzenleyebilir veya taslak olarak kaydedebilir."/>
                                </div>
                                <DataTable

                                    value={data}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >
                                    {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                                    <Column
                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="No"


                                    />

                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '200px'}}
                                        header="Başlık"
                                        sortable
                                        filter


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />
                                    <Column
                                        field={'md_name'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="Modül"


                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"

                                        style={{textAlign: 'center'}}/>


                                    <Column
                                        field={'category_name'}
                                        header="Kategoriler"
                                        filter
                                        sortable

                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>

                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            sortable
                                            filter
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            body={contentTime}

                                            header="Tarihler"
                                            sortable

                                            style={{textAlign: 'center'}}
                                    />

                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        body={actionTemplateApproval}
                                        style={{textAlign: 'center'}}
                                    />


                                </DataTable>
                            </div>
                        </div>


                    </TabPanel>

                    <TabPanel header={table_header_publish} classname="p-mr-2" leftIcon="pi pi-desktop p-mr-2">

                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Yayımlanmış İçerikler</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable

                                    value={contentListPublished}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >

                                    {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                                    <Column
                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="No"


                                    />
                                    <Column
                                        body={views}
                                        style={{fontWeight: 'bold'}}
                                    />

                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', width: '200px'}}
                                        header="Başlık"
                                        sortable
                                        filter


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />
                                    <Column
                                        field={'md_name'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="Modül"


                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"

                                        style={{textAlign: 'center'}}/>


                                    <Column
                                        field={'category_name'}
                                        header="Kategoriler"
                                        filter
                                        sortable

                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>

                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            sortable
                                            filter
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            body={contentTime}

                                            header="Tarihler"
                                            sortable

                                            style={{textAlign: 'center'}}
                                    />

                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        header="İşlevler"
                                        body={actionTemplateAll}
                                        style={{textAlign: 'center'}}
                                    />


                                </DataTable>
                            </div>
                        </div>


                    </TabPanel>


                    <TabPanel header={table_header_draft} classname="p-mr-2" leftIcon="pi pi-calendar-minus p-mr-2">
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Taslağa Kaydedilen İçerikler</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable

                                    value={contentDraftList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >
                                    {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                                    <Column
                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="No"


                                    />

                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '200px'}}
                                        header="Başlık"
                                        sortable
                                        filter


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />
                                    <Column
                                        field={'md_name'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="Modül"


                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"

                                        style={{textAlign: 'center'}}/>


                                    <Column
                                        field={'category_name'}
                                        header="Kategoriler"
                                        filter
                                        sortable

                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>

                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            sortable
                                            filter
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            body={contentTime}

                                            header="Tarihler"
                                            sortable

                                            style={{textAlign: 'center'}}
                                    />

                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        header="İşlevler"
                                        body={actionTemplateDraft}
                                        style={{textAlign: 'center'}}
                                    />


                                </DataTable>
                            </div>
                        </div>


                    </TabPanel>

                    <TabPanel header={table_header_archive} classname="p-mr-2" leftIcon="pi pi pi-eye-slash p-mr-2">
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Arşivlenmiş İçerikler</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable

                                    value={contentArchiveList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >
                                    {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                                    <Column
                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="No"


                                    />

                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '200px'}}
                                        header="Başlık"
                                        sortable
                                        filter


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />
                                    <Column
                                        field={'md_name'}
                                        style={{fontWeight: 'bold', textAlign: 'left'}}
                                        header="Modül"


                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"

                                        style={{textAlign: 'center'}}/>


                                    <Column
                                        field={'category_name'}
                                        header="Kategoriler"
                                        filter
                                        sortable

                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>

                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            sortable
                                            filter
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            body={contentTime}

                                            header="Tarihler"
                                            sortable

                                            style={{textAlign: 'center'}}
                                    />

                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        header="İşlevler"
                                        body={actionTemplateArchive}
                                        style={{textAlign: 'center'}}
                                    />

                                </DataTable>
                            </div>


                        </div>
                    </TabPanel>

                    <TabPanel header={table_header_trash} classname="p-mr-2" leftIcon="pi pi-trash p-mr-2">

                        <Dialog header="UYARI" visible={trashDeleteDialog}
                                style={{width: '20%'}}
                                footer={renderFooterTrashDelete()}
                                onHide={() => setTrashDeleteDialog(false)}>
                            <div className="confirmation-content">
                                <i className="pi pi-trash p-mr-3" style={{fontSize: '2rem'}}/>
                                <span>İçerik Kalıcı Olarak Silinecek. Onaylıyor musunuz?</span>
                            </div>
                        </Dialog>

                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Çöp Kutusu</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable

                                    value={contentTrashList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >
                                    {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                                    <Column
                                        field={'cont_id'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '60px'}}
                                        header="No"


                                    />

                                    <Column
                                        field={'cont_title'}
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '200px'}}
                                        header="Başlık"
                                        sortable
                                        filter


                                    />
                                    <Column field={'user_name'}
                                            header="Yazar"
                                            style={{textAlign: 'center'}}

                                    />

                                    <Column
                                        field={'cont_type'}
                                        header="İçerik Türü"

                                        style={{textAlign: 'center'}}/>


                                    <Column
                                        field={'category_name'}
                                        header="Kategoriler"
                                        filter
                                        sortable

                                        style={{textAlign: 'center', fontWeight: 'bold'}}/>

                                    <Column field={'cont_keywords'}
                                            header="Anahtar Kelime"
                                            sortable
                                            filter
                                            style={{textAlign: 'center'}}
                                    />
                                    <Column field={'cont_createtime'}
                                            body={contentTime}

                                            header="Tarihler"
                                            sortable

                                            style={{textAlign: 'center'}}
                                    />

                                    <Column field={'cont_priority'}
                                            header="Öncelik"
                                            sortable

                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                    />

                                    <Column
                                        header="İşlevler"
                                        body={actionTemplateTrash}
                                        style={{textAlign: 'center'}}
                                    />

                                </DataTable>
                            </div>


                        </div>


                    </TabPanel>


                </TabView>
            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsContentList);



// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsContentList.jsx